module.exports = __webpack_public_path__ + "static/japan-aa1ff2de442bf55ea9f7f5a9ca85f700.jpg";